import { planEatApi } from "../../../../planEatApi/PlanEatApi";
import { IUserContent } from "../../../../planEatApi/PlanEatFacade";
import { VersionsPage } from "../../components/VersionsPage";
import { resolvePlanEatUserId } from "./User";

export const VersionsForUser: React.FC = () => (
    <VersionsPage<IUserContent>
        section="users"
        label="User placement"
        idParam="userId"
        getVersions={planEatApi.getVersionsForUser}
        nameOf={user => user.applicationUserId}
        parentsOf={user => ({ eaterGroupId: user.eaterGroupId, officeId: user.officeId })}
        resolveId={resolvePlanEatUserId}
    />
);
